import React, { Dispatch, SetStateAction, useEffect } from "react";
import { atom } from "recoil";
import styled from "styled-components";
import LineBtn from "../../../../../Button/LineBtn";
import Blank from "../../../../../DefaultStyles/Blank";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import RentPartyList from "./RentPartySection/RentPartyList";

interface RentPartySectionProps {
  rentPartyList?: string[];
  setRentPartyList: Dispatch<SetStateAction<string[]>>;
  modalType?: string;
}

interface SLabel {
  modalType?: string;
}

export default function RentPartySection({
  rentPartyList,
  modalType,
  setRentPartyList,
}: RentPartySectionProps) {
  useEffect(() => {
    console.log("❤️", rentPartyList);
  }, [rentPartyList]);

  return (
    <>
      <ModalLabel>대여 정보</ModalLabel>

      <RentPartyInfoContainer>
        {rentPartyList && rentPartyList?.length > 0 ? (
          <>
            <LabelContainer>
              <Label modalType={modalType}>PID</Label>
              <Label modalType={modalType}>UID</Label>
              <Label>대여 만료일</Label>
            </LabelContainer>

            {rentPartyList?.map((d, index: number) => {
              return (
                <RentPartyList
                  key={index}
                  index={index}
                  modalType={modalType}
                  rentPartyList={rentPartyList}
                  setRentPartyList={setRentPartyList}
                />
              );
            })}
          </>
        ) : (
          <NoRentText>대여 정보가 없습니다.</NoRentText>
        )}

        {modalType !== "view" && (
          <>
            <Blank blankHeight={12} />

            <LineBtn
              btnText="추가"
              icon="add"
              btnHeight={38}
              sPadding={"0 15px 0 12px"}
              btnClickEvent={() => {
                setRentPartyList((prev) => [...prev, ""]);
              }}
            />
          </>
        )}
      </RentPartyInfoContainer>
    </>
  );
}

const RentPartyInfoContainer = styled.div`
  margin-bottom: 16px;
`;

const NoRentText = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: #858c97;
`;

const LabelContainer = styled.div`
  margin-top: 12px;
  display: flex;
  /* justify-content: space-between; */
`;

const Label = styled.label<SLabel>`
  width: ${({ modalType }) => (modalType === "edit" ? "97px" : "109px")};
  display: block;
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: #9a9fa8;

  &:not(:last-child) {
    margin-right: 10px;
  }
`;
